import { Component, OnInit, AfterViewInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})

export class FooterComponent implements OnInit {

  private static COPY_RIGHT_TEXT = 'Copyright ©';
  private static POWERED_BY_TEXT = 'Powered By';
  hostname =  window.location.hostname || environment.host;

  footerNote = FooterComponent.COPY_RIGHT_TEXT;
  redirectCountdown: number = 10;

  availableLinks = new Map<string, string>();
  newUserFlow = false;

  constructor() { }

  ngOnInit(): void {
    // Initialize available links
    this.availableLinks.set('link', 'value' );
  }

}
